import type {
    ConversionRatesOvertimeVisitsListParams,
    ConversionRatesOvertimeVisitsPopListParams,
} from "@similarweb/pro-api-client";

import { useApiQuery } from "app/modules/api-client";
import { parseConversionRateError } from "app/pages/website-analysis/TrafficAndEngagement/conversionRateEmptyStateUtils";

import { selectListData, selectPopData } from "./conversionRatesUtils";

export const useConversionRateData = (
    params: ConversionRatesOvertimeVisitsListParams,
    { enabled }: { enabled: boolean },
) => {
    const queryResult = useApiQuery(
        {
            tag: "WebConversionRates",
            methodName: "conversionRatesOvertimeVisitsList",
            options: { enabled, placeholderData: undefined, select: selectListData },
        },
        params,
    );

    const emptyStateType = queryResult.isError ? parseConversionRateError(queryResult.error) : null;

    return {
        data: queryResult.data,
        isLoading: queryResult.isLoading,
        isError: queryResult.isError,
        emptyStateType,
    };
};

export const useConversionRateDataPOP = (
    params: ConversionRatesOvertimeVisitsPopListParams,
    { enabled }: { enabled: boolean },
) => {
    const queryResult = useApiQuery(
        {
            tag: "WebConversionRates",
            methodName: "conversionRatesOvertimeVisitsPopList",
            options: { enabled, placeholderData: undefined, select: selectPopData },
        },
        params,
    );

    const emptyStateType = queryResult.isError ? parseConversionRateError(queryResult.error) : null;

    return {
        data: queryResult.data,
        isLoading: queryResult.isLoading,
        isError: queryResult.isError,
        emptyStateType,
    };
};
